export default __webpack_public_path__ + "static/media/guard-section.0025b693.svg";